import React, { useEffect, useState } from "react";

import "./caseHistoryListCard.scss";
import { IonCol, IonIcon } from "@ionic/react";
import dayjs from "dayjs";
import { layersOutline } from "ionicons/icons";
import { CaseHistoryService } from "../../../pages/CaseHistory/CaseHistory.service";
import { utilService } from "../../../services/utilService";

interface CaseHistoryListCardProps {
  listData: any;
  index: any;
  getSelectedCaseHistoryCard: (selectedMessageCard: any) => void;
}

const CaseHistoryMessageListCard: React.FC<CaseHistoryListCardProps> = (
  props
) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");

  useEffect(() => {
    if (props.listData.display_name) {
      splitUserDisplayName();
    }
  }, [props.listData.display_name]);

  const splitUserDisplayName = () => {
    const nameArray = props.listData.display_name.split(",");
    setFirstName(nameArray[0]);
    let secondName = nameArray[1] ? nameArray[1] : "";
    setLastName(secondName);
  };

  const getFormattedDateAndTime = (date: any) => {
    const today = dayjs(date).format("MM-DD-YYYY hh:mm A");
    return today;
  };

  const setDisplayName = (name: any) => {
    let patientName;
    if (name[0] === ",") {
      patientName = name.replaceAll(",", "");
    } else {
      patientName = name;
    }
    return patientName;
  };

  return (
    <IonCol className="base-column-messagecard" size="12" size-lg="12">
      <div
        className={`list-card ${props.listData.isSelected ? "active-message-card" : ""
          }`}
        onClick={() => props.getSelectedCaseHistoryCard(props.listData)}
      >
        <div className="content-wrapper">
          <div className="case-history-file-share-icon-div">
            <div
              className={`icon-case-type ${props.listData.case_type_icon
                  ? props.listData.case_type_icon
                  : ""
                }`}
              title={props.listData.case_type_name}
            ></div>
            {props.listData.more_than_one_icon && (
              <span>
                {" "}
                <IonIcon
                  className="multi-case-type-icons"
                  icon={layersOutline}
                ></IonIcon>{" "}
              </span>
            )}
          </div>
          <div className="message-details-container">
            <div
              className="item-cd-title large-font ems-list-title"
              title={`${firstName} ${lastName}`}
            >
              {/* {firstName} {lastName} */}
              {setDisplayName(props.listData.name)}
            </div>
            {props.listData.gender && (
              <div className="item-sub-title small-font">
                {props.listData.gender}
                {props.listData.age && <span> | {props.listData.age} </span>}
                {!props.listData.age && <span> | {props.listData.dob} </span>}
              </div>
            )}
            <div className="item-sub-title time-container small-font">
              Date :
              <span className="time-stamp">
                {getFormattedDateAndTime(props.listData.created_on)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </IonCol>
  );
};

export default CaseHistoryMessageListCard;
